import React from "react";
import {
  Grid,
  TextField,
  MenuItem,
  InputAdornment,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AddIcon from "@mui/icons-material/Add";

const PlayersFilters = ({
  inputStyles,
  searchQuery,
  setSearchQuery,
  selectedSport,
  setSelectedSport,
  selectedLeague,
  setSelectedLeague,
  selectedTeam,
  setSelectedTeam,
  selectedPosition,
  setSelectedPosition,
  handleAdd,
  getUniqueValues,
}) => {
  return (
    <Grid container spacing={1} sx={{ mb: 3 }}>
      <Grid item xs={6} md={2}>
        <TextField
          fullWidth
          label="Search all players"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={inputStyles}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <TextField
          select
          fullWidth
          label="All Sports"
          value={selectedSport}
          onChange={(e) => setSelectedSport(e.target.value)}
          sx={inputStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDownIcon,
          }}
        >
          <MenuItem value="">All Sports</MenuItem>
          {getUniqueValues("sport").map((sport) => (
            <MenuItem key={sport} value={sport}>
              {sport}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <TextField
          select
          fullWidth
          label="All Leagues"
          value={selectedLeague}
          onChange={(e) => setSelectedLeague(e.target.value)}
          sx={inputStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDownIcon,
          }}
        >
          <MenuItem value="">All Leagues</MenuItem>
          {getUniqueValues("league").map((league) => (
            <MenuItem key={league} value={league}>
              {league}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <TextField
          select
          fullWidth
          label="All Teams"
          value={selectedTeam}
          onChange={(e) => setSelectedTeam(e.target.value)}
          sx={inputStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDownIcon,
          }}
        >
          <MenuItem value="">All Teams</MenuItem>
          {getUniqueValues("team").map((team) => (
            <MenuItem key={team} value={team}>
              {team}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6} md={1.5}>
        <TextField
          select
          fullWidth
          label="All Positions"
          value={selectedPosition}
          onChange={(e) => setSelectedPosition(e.target.value)}
          sx={inputStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDownIcon,
          }}
        >
          <MenuItem value="">All Positions</MenuItem>
          {getUniqueValues("position").map((position) => (
            <MenuItem key={position} value={position}>
              {position}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid
        item
        xs={12}
        md="auto"
        sx={{ display: "flex", alignItems: "center" }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{ borderRadius: "10px", height: 52, minWidth: 200 }}
          startIcon={<AddIcon />}
          onClick={handleAdd}
        >
          Add Player
        </Button>
      </Grid>
    </Grid>
  );
};

export default PlayersFilters;
